module.exports = __webpack_public_path__ + "static/x47-7d5e554a3f51ad2344c2dc66a0a8ee25.png";